import * as $ from "jquery";
import CookiesHelper from "../Helpers/helpers.cookies";

export default class CustomerComponent {
    constructor() {
        this.componentSelector = ".signup";
        this.instance = this;
        this.cookies = new CookiesHelper();
    }

    init() {
        let instance = this;
        if ($(instance.componentSelector).length > 0) {
            instance.bind();
        }
        if ($(instance.componentSelector).length > 0) {
            instance.addBriqpayListener(instance);
        }
    }

    bind() {
        let instance = this;
        $('#customer-market').off().on('change', function () {
            var marketId = $('#customer-market').val();
            instance.loadSignup(marketId, instance);
        });
    }

    loadSignup(marketId, instance) {
        axios({
            method: 'post',
            url: "/customer/getsignup",
            data: { market: marketId }
        }).then(function (response) {
            $('#result').html(response.data);
        }).catch(function (response) {
            console.log(response);
        });
    }

    addBriqpayListener(instance) {
        const interval = setInterval(function () {
            if (window._briqpay && typeof window._briqpay.subscribe === 'function') {
                clearInterval(interval);

                window._briqpay.subscribe('make_decision', function (data) {
                    console.log(data);

                    if (data && data.sessionId) {
                        axios({
                            method: 'post',
                            url: '/bp/postv3',
                            data: {
                                sessionid: data.sessionId
                            }
                        }).then(function (response) {
                            console.log(response.data);
                            if (window._briqpay && window._briqpay.v3 && typeof window._briqpay.v3.resumeDecision === 'function') {
                                window._briqpay.v3.resumeDecision();
                            }
                        }).catch(function (response) {
                            console.log(response);
                        });
                    }
                });
            }
        }, 100);
    }
}